/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateSupportTicketStatusDto
 */
export interface UpdateSupportTicketStatusDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSupportTicketStatusDto
     */
    'status': UpdateSupportTicketStatusDtoStatusEnum;
    /**
     * Only read when status is RESOLVED: send the App Store review invitation three days from now. Opt-in — omitting it sends nothing.
     * @type {boolean}
     * @memberof UpdateSupportTicketStatusDto
     */
    'requestReviewAsk'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateSupportTicketStatusDtoStatusEnum {
    New = 'NEW',
    Open = 'OPEN',
    PendingCustomer = 'PENDING_CUSTOMER',
    UnderReview = 'UNDER_REVIEW',
    Planned = 'PLANNED',
    Declined = 'DECLINED',
    Resolved = 'RESOLVED',
    Closed = 'CLOSED'
}


